import { useQuery } from "@tanstack/react-query";
import { ListLevelsQueryFilters, UseListLevelsQueryOptions } from "./types";
import { getLevelsService } from "./service";

export const listLevelsQueryKey = ["level_admin"];

export function useListLevelsQuery(
  filters?: ListLevelsQueryFilters,
  options?: UseListLevelsQueryOptions
) {
  const queryFilters = filters ? { ...filters } : undefined;

  if (queryFilters?.search) {
    delete queryFilters.ids;
  }

  const queryKey = listLevelsQueryKey.concat(JSON.stringify(queryFilters));

  return useQuery({
    queryKey,
    queryFn: async () => getLevelsService(filters),
    ...options,
  });
}
